export const AuthStatus = {
  Logged: "LOGGED",
  InvalidCredentials: "INVALID_CREDENTIALS",
  UserExists: "USER_EXISTS",
  TokenExpired: "TOKEN_EXPIRED",
  MultipleLogin: "MULTIPLE_LOGIN"
}
